import { memo } from 'react';

import Image from 'next/image';
import PoweredByStripeSvg from 'public/powered-by-stripe.svg';

const PoweredByStripe = memo(() => (
  <Image
    alt="Powered by Stripe"
    aria-hidden
    src={PoweredByStripeSvg}
    height="24"
    width="106"
    style={{
      maxWidth: '100%',
      height: 'auto',
    }}
  />
));

export default PoweredByStripe;
